export interface Navigator {
  navigate(path: string): unknown;
}

export interface Navigation {
  readonly basename: string;
  push(path: string): void;
  attach(router: Navigator): void;
}

// Until the router exists, a push goes straight to the browser history; the router starts from there.
export const createNavigation = (basename: string): Navigation => {
  let router: Navigator | null = null;

  return {
    basename,
    push(path: string): void {
      if (router) {
        router.navigate(path);
        return;
      }
      window.history.pushState(null, '', `${basename}${path}`);
    },
    attach(appRouter: Navigator): void {
      router = appRouter;
    },
  };
};

export const stripBasename = (pathname: string, basename: string): string => {
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return pathname;
  }
  const path = pathname.substring(basename.length);
  return path.startsWith('/') ? path : `/${path}`;
};
